import * as React from "react";

export const SpeedBumpEditIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="300.000000pt"
    height="267.000000pt"
    viewBox="0 0 300.000000 267.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g stroke="null">
      <g stroke="null" transform="translate(0.000000,267.000000) scale(0.100000,-0.100000)" fill="#ffffff" id="svg_1">
        <path
          stroke="null"
          d="m1430,2627c-62,-20 -110,-85 -269,-363c-85,-148 -237,-411 -337,-584c-561,-970 -772,-1339 -787,-1378c-39,-97 -8,-195 77,-247l49,-30l1311,-3c956,-2 1322,0 1352,9c53,14 112,63 130,105c22,52 17,131 -10,189c-13,28 -175,313 -361,635c-185,322 -448,776 -582,1010c-325,563 -338,583 -378,619c-54,47 -123,61 -195,38zm111,-38c56,-19 96,-66 181,-214c294,-508 385,-666 555,-960c105,-181 284,-492 398,-690c114,-198 219,-382 231,-410c48,-101 23,-188 -66,-232l-44,-23l-1301,0l-1301,0l-44,23c-66,33 -93,78 -88,148c4,49 15,76 93,210c49,85 164,285 256,444c678,1179 944,1634 968,1658c25,25 87,55 117,57c6,0 26,-5 45,-11z"
          id="svg_2"
        />
        <path
          stroke="null"
          d="m1437,2478c-22,-25 -1108,-1895 -1258,-2166c-39,-71 -38,-112 2,-146l31,-26l1279,0c1390,0 1318,-3 1349,54c12,24 11,32 -6,74c-37,86 -1247,2176 -1280,2210c-21,20 -42,32 -59,32c-19,0 -38,-11 -58,-32zm90,-20c11,-13 75,-120 143,-238c68,-118 153,-267 190,-330c37,-63 119,-205 182,-315c63,-110 218,-378 343,-595c405,-701 425,-737 425,-758c0,-12 -9,-26 -19,-32c-27,-14 -2565,-14 -2592,0c-29,16 -24,38 30,130c55,96 210,367 521,905c377,655 424,736 564,980c125,217 164,275 185,275c4,0 17,-10 28,-22z"
          id="svg_3"
        />
        <path
          stroke="null"
          d="m1344,786c-40,-8 -89,-19 -110,-26c-72,-23 -188,-90 -264,-151c-130,-105 -126,-104 -348,-107l-192,-4l0,-71l0,-72l1067,2l1068,3l3,69l3,69l-198,4c-228,3 -222,1 -363,118c-85,70 -181,119 -290,150c-97,27 -277,35 -376,16zm360,-55c110,-29 188,-69 292,-151c140,-110 152,-115 329,-118c183,-3 197,-5 193,-35l-3,-22l-1020,0c-990,0 -1020,1 -1023,19c-2,10 2,22 10,27c7,5 78,9 158,9c80,0 162,5 183,11c36,10 85,41 219,142c173,131 433,177 662,118z"
          id="svg_4"
        />
      </g>
      <g stroke="null" fill="#ffffff">
        <path
          stroke="currentColor"
          strokeLinejoin="round"
          strokeLinecap="round"
          d="m260.02091,15.24963l13.38832,-12.58846l23.42956,22.02979l-13.38832,12.58828m-23.42956,-22.02961l-45.47339,42.75602c-0.88768,0.8345 -1.3864,1.96676 -1.3864,3.14708l0,20.18609l21.46908,0c1.25543,0 2.4594,-0.46866 3.34713,-1.30361l45.47315,-42.75598m-23.42956,-22.02961l23.42956,22.02961"
        />
      </g>
    </g>
  </svg>
);
